export const DEFAULT_NEW_WINDOW_TARGET = '_blank'

export const DEFAULT_NEW_WINDOW_LOADER_INNER_HTML = `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`

export const DEFAULT_NEW_WINDOW_LOADER_ID = 'Loader'

export const DEFAULT_NEW_WINDOW_LOADING_INLINE_CSS_SCRIPT = `
body {
  margin: 0;
  padding: 0;
}
#${DEFAULT_NEW_WINDOW_LOADER_ID} {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100vw;
  min-height: 100vh;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #000;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`
